module.exports = __webpack_public_path__ + "static/instagram-button@2x-cfbec43d8e1dd14e7760c16cf3473c20.png";